import { keyCodes } from '../../core/commons/a11y';

export const allowedKeyCodes: Array<number> = [keyCodes.enter, keyCodes.space];

const baseAcceptableFilesTypes = {
  /* eslint-disable prettier/prettier */
  Image: '.bmp,.gif,.heic,.heif,.jfi,.jfif,.jpe,.jpeg,.jpg,.png,.tif,.tiff,.webp',
  Document: '.ai,.cdr,.csv,.doc,.docb,.docx,.dot,.dotx,.dwg,.eps,.epub,.fla,.gpx,.ical,.icalendar,.ics,.ifb,.indd,.ipynb,.key,.kml,.kmz,.mobi,.mtf,.mtx,.numbers,.odg,.odp,.ods,.odt,.otp,.ots,.ott,.oxps,.pages,.pdf,.pdn,.pkg,.pot,.potx,.pps,.ppsx,.ppt,.pptx,.psd,.pub,.rtf,.sldx,.txt,.vcf,.xcf,.xls,.xlsx,.xlt,.xltx,.xlw,.xps',
  Video: '.3gp,.avi,.divx,.flv,.m1v,.m2ts,.m4v,.mkv,.mov,.mp4,.mpe,.mpeg,.mpg,.mxf,.ogv,.vob,.webm,.wmv,.xvid',
  Audio: '.aac,.aif,.aiff,.flac,.m4a,.mp3,.wav,.wma',
  /* eslint-enable prettier/prettier */
} as const;
export const acceptableFilesTypes = {
  ...baseAcceptableFilesTypes,
  Gallery: `${baseAcceptableFilesTypes.Image},${baseAcceptableFilesTypes.Video}`,
} as const;

export const facebookAcceptableFileTypes = {
  iOS: {
    Image: 'image/*',
    Document: undefined,
    Video: 'video/*',
    Audio: undefined,
    Gallery: 'image/*,video/*',
  },
  other: {
    Image: 'image/*',
    Document: undefined,
    Video: 'video/*',
    Audio: 'audio/*',
    Gallery: 'image/*,video/*',
  },
} as const;

export const testIds = {
  uploadButton: 'upload-button',
  buttonLabel: 'button-label',
  fileList: 'file-list',
  fileWithIcon: 'file-with-icon',
  xIcon: 'x-icon',
  fileName: 'file-name',
  tooltipContainer: 'tooltip-container',
  tooltipTrigger: 'tooltip-trigger',
  tooltip: 'tooltip',
  numberOfFilesLink: 'number-of-files-link',
  filesPopper: 'files-popper',
  centerEllipsisStart: 'center-elipsis-start',
  centerEllipsis: 'center-ellipsis',
  mobileSeperator: 'mobile-seperator',
  mobileCloseButton: 'mobile-close-button',
};

export const fileNameId = 'file-name';
export const nameSpace = 'upload_button';

export const TRANSLATION_KEYS = {
  'FileUploader.NumberOfSelectedFiles': 'FileUploader.NumberOfSelectedFiles',
  'FileUploader.SingleSelectedFile': 'FileUploader.SingleSelectedFile',
  Upload_Button_Filename_Preview_Text_Filename:
    'Upload_Button_Filename_Preview_Text_Filename',
  FileUploader_Mobile_ClosePopper: 'FileUploader_Mobile_ClosePopper',
} as const;

export const NumberOfFilesTranslationPlaceholder = '{numberOfFiles}';

export const TRANSLATION_FALLBACKS = {
  [TRANSLATION_KEYS[
    'FileUploader.NumberOfSelectedFiles'
  ]]: `${NumberOfFilesTranslationPlaceholder} files selected.`,
  [TRANSLATION_KEYS.Upload_Button_Filename_Preview_Text_Filename]:
    'Example.txt',
  [TRANSLATION_KEYS['FileUploader.SingleSelectedFile']]: '1 file selected.',
  [TRANSLATION_KEYS.FileUploader_Mobile_ClosePopper]: 'Close',
};
